import { COLOR_THEME } from 'consts/statuses';

type ClassValue = string | false | null | undefined | Record<string, unknown>;

export function classNames(...args: ClassValue[]) {
	const classes: string[] = [];
	for (const arg of args) {
		if (!arg) {
			continue;
		}
		if (typeof arg === 'string') {
			classes.push(arg);
		} else {
			for (const key of Object.keys(arg)) {
				if (arg[key]) {
					classes.push(key);
				}
			}
		}
	}
	return classes.join(' ');
}

export function getMode(flowType = '') {
	switch (flowType) {
		case 'eb':
		case 'er':
		case 'rr-eb':
		case 'rr-er':
		case 'rr-su':
			return COLOR_THEME.SECONDARY;
		default:
			return COLOR_THEME.PRIMARY;
	}
}
